import DashboardIcon from '@material-ui/icons/Dashboard';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import { useMemo } from 'react';
import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';
import {
  AdvisorIcon,
  CommunityMembersIcon,
  EventClockIcon,
} from '../../assets/icons';
import { useResourceBundles } from '../../contexts/resource-bundles-context';
import { Pages } from '../../router/constants';
import { Item, SidebarMenu } from '../common/Menu/Sidebar';

export function OfficeHours() {
  const location = useLocation();
  const { rb } = useResourceBundles();

  const menuItems = useMemo<Item[]>(() => {
    const items = [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: DashboardIcon,
        link: Pages.OH_DASHBOARD,
      },
      {
        id: 'advisors',
        label: rb('advisors-u'),
        icon: AdvisorIcon,
        link: Pages.OH_ADVISORS,
      },
      {
        id: 'appointments',
        label: 'Appointments',
        icon: EventClockIcon,
        link: Pages.OH_APPOINTMENTS,
      },
      {
        id: 'community',
        label: 'Community',
        icon: CommunityMembersIcon,
        link: Pages.OH_COMMUNITY_MEMBERS,
      },
      {
        id: 'reports',
        label: 'Reports',
        icon: EqualizerIcon,
        link: Pages.OH_REPORTS,
      },
    ];

    return items.map((i) => {
      const isActive = !!matchPath(location.pathname, { path: i.link });
      
      if (i.id === 'dashboard' && location.pathname.startsWith(Pages.OH_REPORTS)) {
        return { ...i, active: false };
      }
      
      return { ...i, active: isActive };
    });
  }, [location.pathname, rb]);

  return <SidebarMenu items={menuItems} />;
}
